module.exports = __webpack_public_path__ + "static/assets/8c7522fecb8f9035ec5676a51990044f.svg";